import React from 'react'

const CorporateReports = () => {
  return <div>CorporateReports</div>
}

export default CorporateReports
